// extracted by mini-css-extract-plugin
export default {"form":"StyleSearch_form__JPBmv","input":"StyleSearch_input__RKERh"};